<template lang='pug'>
  a.res-order(v-if="type=='order'" @click="$router.push(`/core/orders/order/${entity.id}`); $emit('nav')" title='Order')
    div {{entity.id}}
    div(title="Order product")
      span(v-if="entity.product") {{entity.product.name}}
    div
      p
        strong(title="Order name") {{entity.description}}
    div(title="Order size") {{entity.size}}
    div {{entity.created | date}}
    div
      span {{entity.createdBy && entity.createdBy.username}}
  a.res-location(v-else-if="type=='location'", @click="$router.push(`/trackntrace/business-locations/${entity.id}`); $emit('nav')", title='Business location')
    div {{entity.id}}
    div(title="Location city") {{entity.city}}
    div
      p
        strong(title="Location name") {{entity.name}}
    div(title="Location category") {{entity.category}}
    div
    div
  a.res-section(v-else-if="type=='section'", @click="$router.push(`/core/orders/order/${entity.orderId}/section/${entity.id}/view`); $emit('nav')", title='Section')
    div {{entity.id}}
    div(title="Section notes") {{entity.comment}}
    div
      p
        strong(title="Section product") {{entity.product ? entity.product.name : ''}}
    div(title="Section size") {{entity.size}}
    div {{entity.created | date}}
    div
      span {{entity.createdBy && entity.createdBy.username}}
  a.res-roll(v-else-if="type=='roll'", @click="$router.push(`/core/orders/order/${entity.orderId}/rolls/roll/${entity.id}`); $emit('nav')", title='Roll')
    div {{entity.id}}
    div
    div
      p
        strong(title="Roll description") {{entity.description}}
    div {{entity.totalNumberOfCodes}}
    div
    div
  a.res-audit-log(v-else-if="type=='auditlog'", @click="$router.push(`/security/audit`); $emit('nav')", title='Audit log')
    div {{entity.pkId}}
    div(title="Property name") {{entity.changes[0].propertyName}}
    div
      p
        strong(title="Operation") {{entity.operation}}
    div(title="Class name") {{entity.className}}
    div {{entity.timestamp | date}}
    div
       span {{entity.user.username}}
  div(v-else='')
    | Unknown result type: {{type}}

</template>

<script>
import { dateFilter } from '@/filters/filters'

export default {
  props: ['type', 'entity'],
  name: 'SearchResult',
  filters: {
    date: dateFilter
  },
  created() {
    if (this.type === 'section') {
      this.entity.size = (this.entity.last.codeIndex - this.entity.first.codeIndex) + 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/SearchResult.vue